import axios from 'axios';
import {
  ApiService,
  SettingsService,
  LicenseService,
  UpdateService,
  DeviceService,
  StatisticsService,
  OrderService,
  CustomerService,
  UserService,
  ArticleService,
  CatalogueService,
  PriceListService,
  ImportEntitiesService,
  DashboardService,
  StockService,
  ReportsService,
  ProjectsService,
  CustomerServiceOne,
  ContactService,
  FirebaseServiceOne,
  ArticleServiceOne,
  PartServiceOne,
  MachineServiceOne,
  ContactDetailsService,
  SuppliersService,
  CorporationService,
  CompanyService,
  OperationalAreaService,
  ShiftPositionsService,
  ApiManagementService,
  TeamsService,
  ShiftTemplateService,
  ShiftDayService,
  ListService,
  UserActivityLogService
} from './api';
import AuthService from './auth.service';
import AuthStorageService from './auth-storage.service';
import LocalStorageService from './local-storage.service';
import { ErrorHandler } from './error-handler';
import appConfig from '../app.config';

const localStorageService = new LocalStorageService(localStorage);
const authStorageService = new AuthStorageService(localStorageService);
const apiService = new ApiService(
  axios,
  appConfig.apiUrl,
  appConfig.enviromentServerUrl,
  appConfig.apiRequestTimeout,
  new ErrorHandler(),
  authStorageService
);

const authService = new AuthService(apiService, authStorageService);
const settingsService = new SettingsService(apiService);
const licenseService = new LicenseService(apiService);
const updateService = new UpdateService(apiService);
const deviceService = new DeviceService(apiService);
const statisticsService = new StatisticsService(apiService);
const orderService = new OrderService(apiService);
const customerService = new CustomerService(apiService);
const userService = new UserService(apiService);
const articleService = new ArticleService(apiService);
const catalogueService = new CatalogueService(apiService);
const priceListService = new PriceListService(apiService);
const importEntitiesService = new ImportEntitiesService(apiService);
const dashboardService = new DashboardService(apiService);
const stockService = new StockService(apiService);
const reportsService = new ReportsService(apiService);
const projectsService = new ProjectsService(apiService, reportsService);
const customerServiceOne = new CustomerServiceOne(apiService);
const contactService = new ContactService(apiService);
const firebaseServiceOne = new FirebaseServiceOne(apiService);
const articleServiceOne = new ArticleServiceOne(apiService);
const partServiceOne = new PartServiceOne(apiService);
const machineServiceOne = new MachineServiceOne(apiService);

const contactDetailsService = new ContactDetailsService(apiService);
const suppliersService = new SuppliersService(apiService);
const corporationService = new CorporationService(apiService);
const companyService = new CompanyService(apiService);
const operationalAreaService = new OperationalAreaService(apiService);
const shiftPositionsService = new ShiftPositionsService(apiService);
const shiftTemplateService = new ShiftTemplateService(apiService);
const shiftDayService = new ShiftDayService(apiService);
const teamsService = new TeamsService(apiService);
const listService = new ListService(apiService);
const userActivityLogService = new UserActivityLogService(apiService);

const apiManagementService = new ApiManagementService(apiService);

export {
  apiService,
  localStorageService,
  settingsService,
  licenseService,
  deviceService,
  statisticsService,
  orderService,
  customerService,
  authService,
  authStorageService,
  userService,
  articleService,
  catalogueService,
  priceListService,
  importEntitiesService,
  dashboardService,
  stockService,
  reportsService,
  updateService,
  projectsService,
  customerServiceOne,
  contactService,
  firebaseServiceOne,
  articleServiceOne,
  partServiceOne,
  machineServiceOne,
  contactDetailsService,
  suppliersService,
  corporationService,
  companyService,
  operationalAreaService,
  shiftPositionsService,
  apiManagementService,
  teamsService,
  shiftTemplateService,
  listService,
  shiftDayService,
  userActivityLogService
};
